import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Check, ArrowRight } from 'lucide-react';
import { packages } from '../data/mockData';
import { useLanguage } from '../translations/LanguageContext';

const Packages = () => {
  const { t } = useLanguage();
  
  return (
    <div className="min-h-screen bg-[#2e5453]">
      {/* Hero Section */}
      <section className="bg-[#3d6a68] py-16">
        <div className="container mx-auto px-4 text-center">
          <Badge className="bg-[#96ba1e] text-[#2e5453] hover:bg-[#a8c82e] mb-4">
            {t('nav.packages')}
          </Badge>
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-[#96ba1e]">
            {t('packages.title')}
          </h1>
          <p className="text-xl text-[#c4d88f] max-w-3xl mx-auto">
            {t('packages.description')}
          </p>
        </div>
      </section>

      {/* Packages Grid */}
      <section className="py-16 bg-[#2e5453]">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {packages.map((pkg) => (
              <Card
                key={pkg.id}
                className={`relative transition-all hover:shadow-2xl bg-[#3d6a68] border-[#96ba1e] ${
                  pkg.popular ? 'border-2 shadow-xl scale-105' : 'border'
                }`}
              >
                {pkg.popular && (
                  <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 z-10">
                    <Badge className="bg-[#96ba1e] text-[#2e5453] hover:bg-[#a8c82e] px-4 py-1 text-sm">
                      {t('home.mostPopular')}
                    </Badge>
                  </div>
                )}
                {pkg.bestValue && (
                  <div className="absolute -top-3 right-4 z-10">
                    <Badge className="bg-green-500 text-white hover:bg-green-600 px-3 py-1">
                      {t('home.bestValue')}
                    </Badge>
                  </div>
                )}
                <CardContent className="p-8 space-y-6">
                  <div className="text-center pb-6 border-b border-[#96ba1e]/30">
                    <h3 className="text-3xl font-bold text-[#96ba1e] mb-3">{pkg.name}</h3>
                    <div>
                      <span className="text-5xl font-bold text-[#96ba1e]">€{pkg.price}</span>
                      <span className="text-[#c4d88f] text-lg ml-2">{t('home.perParty')}</span>
                    </div>
                  </div>
                  <ul className="space-y-4">
                    {pkg.features.map((feature, index) => (
                      <li key={index} className="flex items-start space-x-3">
                        <Check className="w-6 h-6 text-[#96ba1e] flex-shrink-0 mt-0.5" />
                        <span className="text-[#c4d88f] text-lg">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <Link to="/booking" state={{ selectedPackage: pkg.id }}>
                    <Button
                      size="lg"
                      className={`w-full mt-6 ${
                        pkg.popular
                          ? 'bg-[#96ba1e] hover:bg-[#a8c82e] text-[#2e5453]'
                          : 'bg-[#2e5453] hover:bg-[#3d6a68] text-[#96ba1e] border-2 border-[#96ba1e]'
                      }`}
                    >
                      Select {pkg.name} <ArrowRight className="w-5 h-5 ml-2" />
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-[#3d6a68]">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-[#96ba1e]">{t('packages.readyToBook')}</h2>
          <p className="text-xl mb-8 text-[#c4d88f] max-w-2xl mx-auto">
            {t('packages.readyDescription')}
          </p>
          <Link to="/booking">
            <Button size="lg" className="bg-[#96ba1e] text-[#2e5453] hover:bg-[#a8c82e] px-10 py-6 text-lg font-bold">
              {t('packages.bookNow')} <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Packages;
